const clickCollect = (state = {}, data) => {
    switch (data.type) {
        case 'UPDATE_COLLECTION_STORES':
            return {
                ...state,
                stores: data.stores,
            };
        case 'SET_COLLECTION_SELECTED_STORE':
            return {
                ...state,
                selectedStore: data.storeId,
            };
        case 'SET_COLLECTION_ERROR':
            return {
                ...state,
                error: data.code,
            };
        default:
            return state;
    }
};

export default clickCollect;
